import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-email">
          <a 
            href="mailto:academiabarcodepapel@gmail.com"
            className="email-link"
          >
            academiabarcodepapel@gmail.com
          </a>
        </div>

        <div className="footer-social">
          <a 
            href="https://www.instagram.com/academiabarcodepapel/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <Instagram size={24} />
          </a>
          <a 
            href="https://www.facebook.com/profile.php?id=100092545151885"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <Facebook size={24} />
          </a>
        </div>

        <div className="footer-links">
          <a 
            href="/politica-privacidade"
            className="footer-link"
          >
            Política de Privacidade e Termos de Uso
          </a>
          <a 
            href="/regulamento"
            className="footer-link"
          >
            Regulamento
          </a>
        </div>

        <div className="footer-copyright">
          ©2025 por Barco de Papel - Academia de Criatividade.
        </div>
      </div>
    </footer>
  );
}